(() => {
  if (customElements.get('pupmd-checkout-links-v2')) return;

  const DEFAULT_HOSTS = 'go.pupmd.com';
  const DEFAULT_FORWARD =
    'utm_*, gclid, gbraid, wbraid, fbclid, ttclid, msclkid, twclid, li_fat_id, epik, irclickid, cjevent, gad_source, ref, aff, sc_ref, subid, sub1, sub2';

  const BASE_HREF_ATTRIBUTE = 'data-pupmd-base-href';

  /**
   * @param {string} value
   * @returns {string[]}
   */
  const parseList = (value) =>
    value
      .split(/[\s,]+/)
      .map((entry) => entry.trim().toLowerCase())
      .filter(Boolean);

  class PupmdCheckoutLinksV2 extends HTMLElement {
    /** @type {AbortController | null} */
    #abort = null;

    /** @type {string[]} */
    #hosts = [];

    /** @type {URLSearchParams} */
    #incoming = new URLSearchParams();

    connectedCallback() {
      this.#hosts = parseList(this.dataset.hosts || DEFAULT_HOSTS);
      if (this.#hosts.length === 0) return;

      const patterns = parseList(this.dataset.forward || DEFAULT_FORWARD);
      this.#incoming = new URLSearchParams();

      new URLSearchParams(window.location.search).forEach((value, name) => {
        if (value && this.#isForwarded(name, patterns)) this.#incoming.set(name, value);
      });

      this.#decorateAll();

      this.#abort = new AbortController();

      /**
       * @param {Event} event
       */
      const decorateFromEvent = (event) => {
        if (!(event.target instanceof Element)) return;
        this.#decorate(event.target.closest('a[href]'));
      };

      for (const type of ['pointerdown', 'click']) {
        this.addEventListener(type, decorateFromEvent, { capture: true, signal: this.#abort.signal });
      }
    }

    disconnectedCallback() {
      this.#abort?.abort();
      this.#abort = null;
    }

    refresh() {
      this.#decorateAll();
    }

    /**
     * @param {string} name
     * @param {string[]} patterns
     * @returns {boolean}
     */
    #isForwarded(name, patterns) {
      const param = name.toLowerCase();

      return patterns.some((pattern) => {
        if (pattern === '*') return true;
        if (pattern.endsWith('*')) return param.startsWith(pattern.slice(0, -1));
        return param === pattern;
      });
    }

    #decorateAll() {
      for (const link of this.querySelectorAll('a[href]')) this.#decorate(link);
    }

    /**
     * @param {Element | null} link
     */
    #decorate(link) {
      if (!(link instanceof HTMLAnchorElement)) return;

      const base = link.getAttribute(BASE_HREF_ATTRIBUTE) || link.getAttribute('href');
      if (!base) return;

      /** @type {URL} */
      let url;
      try {
        url = new URL(base, window.location.href);
      } catch {
        return;
      }

      const host = url.hostname.toLowerCase();
      if (!this.#hosts.some((entry) => host === entry || host.endsWith(`.${entry}`))) return;

      link.setAttribute(BASE_HREF_ATTRIBUTE, base);

      const merged = new URLSearchParams(url.search);
      this.#incoming.forEach((value, name) => merged.set(name, value));

      merged.set('utm_device', window.matchMedia('(max-width: 768px)').matches ? 'mobile' : 'desktop');

      const utmTest = this.dataset.utmTest?.trim();
      if (utmTest) merged.set('utm_test', utmTest);

      const search = merged.toString();
      url.search = search ? `?${search}` : '';
      link.setAttribute('href', url.toString());
    }
  }

  customElements.define('pupmd-checkout-links-v2', PupmdCheckoutLinksV2);
})();
